import React from 'react';
import {
  string,
  func,
  arrayOf,
  shape,
  array,
  element,
  object,
  bool,
} from 'prop-types';
import styled from 'styled-components';
import Wrapper from '../Wrapper';
import { SubBodyText } from '../Text/Heading';
import CheckboxOption from './CheckboxOption';

const Title = styled(SubBodyText)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.darkBlack};
`;

const CheckboxesGroup = ({
  title,
  iconPrefixTitle,
  displayTextProp,
  selectedOptions,
  onChange,
  options,
  checkboxStyles,
  isMoveEnabled,
}) => {
  const onChangeHandler = (id, isSelected) => {
    if (isSelected) {
      onChange(selectedOptions.filter(opt => opt !== id));
    } else {
      onChange([...selectedOptions, id]);
    }
  };
  return (
    <Wrapper>
      <Wrapper pb={3} display="flex" flexDirection="row">
        {iconPrefixTitle}
        <Title pl={10}>{title}</Title>
      </Wrapper>
      <Wrapper display="flex" flexDirection="column">
        {options.map(item => (
          <Wrapper key={item.id} {...checkboxStyles}>
            <CheckboxOption
              id={item.id}
              isSelected={selectedOptions.includes(item.id)}
              text={item[displayTextProp]}
              onChange={onChangeHandler}
              isMoveEnabled={isMoveEnabled}
            />
          </Wrapper>
        ))}
      </Wrapper>
    </Wrapper>
  );
};

CheckboxesGroup.propTypes = {
  title: string,
  selectedOptions: array,
  onChange: func,
  options: arrayOf(
    shape({
      id: string,
      text: string,
    })
  ),
  iconPrefixTitle: element,
  displayTextProp: string,
  checkboxStyles: object,
  isMoveEnabled: bool,
};

CheckboxesGroup.defaultProps = {
  onChange: () => {},
  selectedOptions: [],
  options: [],
  displayTextProp: 'text',
  checkboxStyles: {
    padding: '8px 0',
    marginLeft: '9px',
  },
  isMoveEnabled: false,
};

export default CheckboxesGroup;
